import * as React from 'react';
export var defaultPressableContextProps = {
  color: 'default',
  cursor: 'default',
  display: 'inline-flex',
  fontLineHeight: 20,
  fontSize: 14,
  fontWeight: 'regular',
  height: 'auto',
  pressableContextClasses: 'PressableContext',
  width: 'auto'
};
var PressableContext = React.createContext(defaultPressableContextProps);
export default PressableContext;